import * as React from 'react';
import { useFullscreenElement } from './fullscreen.js';
/**
 * Where floating content (popovers, menus, select lists, tooltips) portals
 * to. `null` means the document body. A modal `DialogContent` or
 * `SheetContent` provides its own element, so a popover opened inside it
 * mounts inside the dialog's focus trap and dismissable layer instead of
 * behind them — without this, a Popconfirm on a sheet's close button is
 * dismissed by the sheet the moment it opens.
 */
export const OverlayContainerContext = React.createContext(null);
/**
 * The portal container for floating content: the enclosing dialog, else the
 * full-screen element (see `useFullscreenElement`), else `undefined` for the body.
 */
export function useOverlayContainer() {
    const fullscreen = useFullscreenElement();
    return React.useContext(OverlayContainerContext) ?? fullscreen ?? undefined;
}
function assignRef(ref, value) {
    if (typeof ref === 'function')
        ref(value);
    else if (ref)
        ref.current = value;
}
/**
 * A ref callback that records the element and forwards it, so a modal content
 * can provide itself as the overlay container.
 */
export function useOverlayContainerRef(forwarded) {
    const [node, setNode] = React.useState(null);
    const ref = React.useCallback((next) => {
        setNode(next);
        assignRef(forwarded, next);
    }, [forwarded]);
    return [node, ref];
}
//# sourceMappingURL=overlay-container.js.map